import { Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./ExcursionActivityLevel.module.scss";
import clsx from "clsx";
import { Icon } from "@silversea-ssc/ui-components-react";
import { useExcursionsMicroContent } from "src/page-components/cruise/ExcursionsMicroContentProvider";

interface ExcursionActivityLevelProps {
  level: number;
  titleClassName?: string;
}

const ExcursionActivityLevel: React.FC<
  React.PropsWithChildren<ExcursionActivityLevelProps>
> = ({ level, titleClassName = undefined }) => {
  const { activityLevels = [] } = useExcursionsMicroContent();
  const { label, iconStep = 0 } =
    activityLevels.find((x) => x?.iconStep == level) || {};

  const icons = Array(4)
    .fill("activity-level-empty")
    .fill("activity-level-full", 0, iconStep);
  return (
    <div className={styles.container}>
      <div
        className={clsx({
          [styles.title]: true,
          [titleClassName || ""]: titleClassName
        })}
      >
        <Trans>Activity Level</Trans>
      </div>
      <div className={styles.icons}>
        {icons.map((i, index) => (
          <Icon
            key={`${i}-${index}`}
            name={i}
            size="0.5x"
            padding="inline"
            className={styles.icon}
          />
        ))}
      </div>
      <div className={styles.label}>{label?.localized}</div>
    </div>
  );
};

export default ExcursionActivityLevel;
